import React from 'react';

export const NoDownload = () => (
  <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.4"
      d="M4.28758 5.68457C1.89591 5.68457 1.16675 6.41374 1.16675 8.8054V9.8904C1.16675 11.0862 1.34758 11.8679 1.83175 12.3462L5.30841 8.86957C5.47175 8.2804 5.93258 7.81957 6.52175 7.65624L8.49341 5.68457H4.28758Z"
      fill="#1862D1"
    />
    <path
      opacity="0.4"
      d="M12.8334 9.89046V8.80546C12.8334 6.59462 12.2092 5.80712 10.2317 5.69629L8.02087 7.90712L5.5592 10.3688L3.01587 12.9121C3.3717 12.9821 3.79754 13.0113 4.28754 13.0113H9.71254C12.1042 13.0113 12.8334 12.2821 12.8334 9.89046Z"
      fill="#1862D1"
    />
    <path
      d="M12.6993 1.47891C12.5243 1.30391 12.2384 1.30391 12.0634 1.47891L1.30093 12.2472C1.12593 12.4222 1.12593 12.7081 1.30093 12.8831C1.38843 12.9647 1.49926 13.0114 1.61593 13.0114C1.73259 13.0114 1.84343 12.9647 1.93093 12.8772L12.6993 2.10891C12.8801 1.93391 12.8801 1.65391 12.6993 1.47891Z"
      fill="#1862D1"
    />
    <path
      d="M9.26334 7.42889L7.30918 9.38306C7.14001 9.55223 6.86001 9.55223 6.69084 9.38306L4.73668 7.42889C4.56751 7.25973 4.56751 6.97973 4.73668 6.81056C4.90584 6.64139 5.18584 6.64139 5.35501 6.81056L6.56251 8.01806V1.78223C6.56251 1.54306 6.76084 1.34473 7.00001 1.34473C7.23918 1.34473 7.43751 1.54306 7.43751 1.78223V8.01806L8.64501 6.81056C8.73251 6.72306 8.84334 6.68223 8.95418 6.68223C9.06501 6.68223 9.17584 6.72306 9.26334 6.81056C9.43834 6.97973 9.43834 7.25389 9.26334 7.42889Z"
      fill="#1862D1"
    />
    <path
      d="M12.6993 1.47891C12.5243 1.30391 12.2384 1.30391 12.0634 1.47891L1.30093 12.2472C1.12593 12.4222 1.12593 12.7081 1.30093 12.8831C1.38843 12.9647 1.49926 13.0114 1.61593 13.0114C1.73259 13.0114 1.84343 12.9647 1.93093 12.8772L12.6993 2.10891C12.8801 1.93391 12.8801 1.65391 12.6993 1.47891Z"
      fill="#1862D1"
    />
  </svg>
);
